import { gql, TypedDocumentNode } from "@apollo/client";

import { ManagedEntitiesGroupedByStacksConnection, PageInfo, Stack } from "types/generated";

const SEARCH_MANAGED_ENTITIES_GROUP_BY_STACKS_FRAGMENT = gql`
  fragment SearchManagedEntitiesGroupByStacksFragment on SearchManagedEntitiesGroupedByStacksOutput {
    edges {
      cursor
      node {
        id
        count
        drifted
        updatedAt
        stackName
        stackSpaceID
        stackSpaceName
        stackVendor
      }
    }
    pageInfo {
      endCursor
      startCursor
      hasNextPage
    }
  }
`;

type SearchManagedEntitiesGroupByStacksData = {
  searchManagedEntitiesGroupByStacks: {
    edges: Array<ManagedEntitiesGroupedByStacksConnection>;
    pageInfo: Pick<PageInfo, "endCursor" | "startCursor" | "hasNextPage">;
  };
};

export const SEARCH_MANAGED_ENTITIES_GROUP_BY_STACKS: TypedDocumentNode<SearchManagedEntitiesGroupByStacksData> = gql`
  query SearchManagedEntitiesGroupByStacks($input: SearchInput!) {
    searchManagedEntitiesGroupByStacks(input: $input) {
      ...SearchManagedEntitiesGroupByStacksFragment
    }
  }
  ${SEARCH_MANAGED_ENTITIES_GROUP_BY_STACKS_FRAGMENT}
`;

type SearchStackManagedEntitiesGroupByStacksData = {
  stack: Pick<Stack, "id"> & SearchManagedEntitiesGroupByStacksData;
};

export const SEARCH_STACK_MANAGED_ENTITIES_GROUP_BY_STACKS: TypedDocumentNode<SearchStackManagedEntitiesGroupByStacksData> = gql`
  query SearchStackManagedEntitiesGroupByStacks($stackId: ID!, $input: SearchInput!) {
    stack(id: $stackId) {
      id
      searchManagedEntitiesGroupByStacks(input: $input) {
        ...SearchManagedEntitiesGroupByStacksFragment
      }
    }
  }
  ${SEARCH_MANAGED_ENTITIES_GROUP_BY_STACKS_FRAGMENT}
`;
